<template>
    <v-btn
        flat
        class="hidden-md-and-up text-xs-right"
        @click="btnClick"
    >{{ 'Filters' | translation }}</v-btn>
</template>

<script>
export default {
    name: 'SearchFilterBtn',
    methods: {
        btnClick() {
            this.$emit('toggle-drawer');
        }
    }
};
</script>